import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostBerichtsVorlageCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostBerichtsVorlageCommandService],
  exports: []
})
export class PostBerichtsVorlageCommandServiceModule { }
